import { FC, useCallback, useState } from "react";
import { Check } from "lucide-react";
import { ICON_ONLY_BUTTON_ICON_STYLES } from "../../../styles";
import { Button } from "../../molecules/Button";
import { VoidFunc } from "../../../../helpers/functions/types";

const MANUAL_FIELD_STYLES =
  "border border-stone-300 dark:border-none focus:border-stone-500 focus:ring-stone-500 dark:border-stone-900";

export const BadgedDataInput: FC<{
  submitValue: VoidFunc<string>;
  placeholder: string;
}> = ({ submitValue, placeholder }) => {
  const [inputManualValue, setInputManualValue] = useState<string>("");
  const onSubmit = useCallback(() => {
    submitValue(inputManualValue);
    setInputManualValue("");
  }, [inputManualValue, submitValue]);

  return (
    <label htmlFor="manualClass" className="h-9 mb-2 box-border flex">
      <input
        id="manualClass"
        type="text"
        className={`${MANUAL_FIELD_STYLES} h-9 flex-1 rounded-md pl-3 text-sm text-stone-900 placeholder-stone-400 dark:bg-stone-700 dark:text-stone-100 dark:placeholder-stone-400`}
        placeholder={placeholder}
        value={inputManualValue}
        onChange={({ target }) => setInputManualValue(target.value)}
        onKeyUp={(event) => {
          if (event.key === "Enter") {
            onSubmit();
          }
        }}
      />

      <Button
        title="Save value"
        customId="manualUpdateValue"
        className={`${ICON_ONLY_BUTTON_ICON_STYLES} ml-2 h-9 w-9 rounded-md bg-stone-100 p-2.5 hover:bg-stone-200 focus:outline-none focus:ring-1 focus:ring-stone-500 dark:bg-stone-700 dark:hover:bg-stone-600 border border-stone-300 dark:border-none focus:border-stone-500 dark:border-stone-900 disabled:hover:bg-stone-100 disabled:hover:dark:bg-stone-700`}
        buttonType="iconOnly"
        onClick={onSubmit}
        disabled={!inputManualValue.length}
      >
        <Check />
      </Button>
    </label>
  );
};
